import React from "react";
import { Nav, NavLink, NavMenu } from "./NavbarElements";
import { useTranslation, Translation } from "react-i18next";
import ChangeLanguage from "../../components/ChangeLanguage";
import { observer, inject } from "mobx-react";
import { useNavigate, useLocation } from "react-router-dom";
import styled from "styled-components";

const Link = styled.a(({ active }) => ({
  color: active ? "#BE1E2C" : "rgb(81, 83, 88)",
  textDecoration: "none",
  fontSize: "18px",
  fontWeight: "300",
  height: "100%",
  cursor: "pointer",
  textTransform: "capitalize",
}));

const Navbar = ({ userStore, setLanguageObj, productsStore }) => {
  const { t, i18n } = useTranslation("navBar");
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  const handleProductOnClick = () => {
    // clear store
    productsStore.setActiveCategory("");
    productsStore.setActiveItem("");
    productsStore.clearSearch();
    navigate("/");
  };

  const openNewProjectOrder = () => {
    navigate("/new-project");
  };

  return (
    <Nav>
      <NavMenu show={userStore.isAuthenticated}>
        <Link onClick={handleProductOnClick} active={path.includes("/catalog")}>
          {t("products")}
        </Link>
        <Link onClick={openNewProjectOrder} active={path.includes("/new-project")}>
          {t("new_project_order")}
        </Link>
        <Link onClick={() => navigate("/update-project")} active={path.includes("/update-project")}>
          {t("update_project_order")}
        </Link>
        <NavLink
          to={
            i18n.language === "en"
              ? "https://acp-ltd.co.il/about/?lang=en"
              : "https://acp-ltd.co.il/%d7%90%d7%95%d7%93%d7%95%d7%aa/"
          }
          target="_blank"
        >
          {t("about")}
        </NavLink>
        <NavLink
          to={
            i18n.language === "en"
              ? "https://acp-ltd.co.il/color-catalog/?lang=en"
              : "https://acp-ltd.co.il/%d7%a7%d7%98%d7%9c%d7%95%d7%92-%d7%a6%d7%91%d7%a2%d7%99%d7%9d/"
          }
          target="_blank"
        >
          {t("color_catalog")}
        </NavLink>
        <NavLink
          to={
            i18n.language === "en"
              ? "https://acp-ltd.co.il/articles/?lang=en"
              : "https://acp-ltd.co.il/%d7%9e%d7%90%d7%9e%d7%a8%d7%99%d7%9d/"
          }
          target="_blank"
        >
          {t("blog")}
        </NavLink>
      </NavMenu>
      <Translation>{(t) => <ChangeLanguage t={t} setLanguageObj={setLanguageObj} />}</Translation>
    </Nav>
  );
};

export default inject("userStore", "productsStore")(observer(Navbar));
